import * as React from 'react';
import styled from 'styled-components';
import kebabCase from 'lodash/kebabCase';

import { CheckIcon } from '@origin-digital/icon';
import { BREAK_POINTS } from '@origin-digital/style-guide';

import {
  HiddenInput,
  Porthole,
  FauxInput,
  MultiChoiceIndicator,
  CheckboxText,
  Label,
} from './Checkbox.styles';

export const Checkbox = ({ id = null, label, children, name, type = 'checkbox', ...props }) => {
  const checkboxId = id || `checkbox-${name}-${kebabCase(label)}`;
  return (
    <>
      <HiddenInput {...props} id={checkboxId} type={type} name={name} />
      <FauxInput>
        {type === 'checkbox' && (
          <MultiChoiceIndicator>
            <CheckIcon size={18} color="white" />
          </MultiChoiceIndicator>
        )}
        <Porthole>{children}</Porthole>
        <CheckboxText size="lg" fontWeight="medium">
          {label}
        </CheckboxText>
        <Label htmlFor={checkboxId} />
      </FauxInput>
    </>
  );
};

export const CheckboxContainer = styled.div`
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }

  & > * {
    margin-bottom: 16px;

    @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
      margin-bottom: 0;
      &:not(:last-child) {
        margin-right: 24px;
      }
    }
    @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
      &:not(:last-child) {
        margin-right: 32px;
      }
    }
  }
`;
